import { SortFilter } from "src/generated/graphql";

export const SORT_OPTIONS = [
    { label: "What's New", key: SortFilter['New'] },
    { label: "Popularity", key: SortFilter['Popularity'] },
    { label: "Better Discount", key: SortFilter['Discount'] },
    { label: "Price: High to Low", key: SortFilter['Costly'] },
    { label: "Price: Low to High", key: SortFilter['Budget'] }
]

export const COLOR_OPTIONS = [
    "AliceBlue",
    "AntiqueWhite",
    "Aqua",
    "Aquamarine",
    "Azure",
    "Beige",
    "Bisque",
    "Black",
    "BlanchedAlmond",
    "Blue",
    "BlueViolet",
    "Brown",
    "BurlyWood",
    "CadetBlue",
    "Chartreuse",
    "Chocolate",
    "Coral",
    "CornflowerBlue",
    "Cornsilk",
    "Crimson",
    "Cyan",
    "DarkBlue",
    "DarkCyan",
    "DarkGoldenRod",
    "DarkGray",
    "DarkGrey",
    "DarkGreen",
    "DarkKhaki",
    "DarkMagenta",
    "DarkOliveGreen",
    "DarkOrange",
    "DarkOrchid",
    "DarkRed",
    "DarkSlateBlue",
    "DarkSlateGray",
    "DarkSlateGrey",
    "DarkTurquoise",
    "DarkViolet",
    "DeepPink",
    "DeepSkyBlue",
    "DimGray",
    "DimGrey",
    "DodgerBlue",
    "FireBrick",
    "FloralWhite",
    "ForestGreen",
    "Fuchsia",
    "Gainsboro",
    "GhostWhite",
    "Gold",
    "GoldenRod",
    "Gray",
    "Grey",
    "Green",
    "GreenYellow",
    "HoneyDew",
    "HotPink",
    "IndianRed",
    "Indigo",
    "Ivory",
    "MediumSeaGreen",
    "MediumSlateBlue",
    "MediumTurquoise",
    "MediumVioletRed",
    "MidnightBlue",
    "MintCream",
    "MistyRose",
    "Moccasin",
    "NavajoWhite",
    "Navy",
    "OldLace",
    "Olive",
    "OliveDrab",
    "Orange",
    "OrangeRed",
    "Orchid",
    "PaleGoldenRod",
    "PaleGreen",
    "PaleTurquoise",
    "PaleVioletRed",
    "PapayaWhip",
    "SeaShell",
    "Sienna",
    "Silver",
    "SkyBlue",
    "SlateBlue",
    "SlateGray",
    "SlateGrey",
    "Snow",
    "WhiteSmoke",
    "Yellow",
    "YellowGreen",
];

export const PRICE_OPTIONS = ["Rs. 134 to Rs. 3051", "Rs. 3051 to Rs. 5968", "Rs. 5968 to Rs. 8885", "Rs. 8885 to Rs. 11802"];

export const DISCOUNT_OPTIONS = [
    "10 % and above",
    "20 % and above",
    "30 % and above",
    "40 % and above",
    "50 % and above",
    "60 % and above",
    "70 % and above",
    "80 % and above"
]
